// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4a8a33a","239":"1e08152d","453":"3756ea44","732":"3c6e8979"}[chunkId] + ".chunk.js";
};